import type { ISitemaps } from "~/types/kentico/sitemaps";
import api from "../auth/api";
import { useSettings } from "~/store/settings";

export default async function fetchSitemap() {
	const store = useSettings();

	await api<ISitemaps>({
		url: `/cron/sitemaps/synapseV2/${store.config?.regionCode}/${store.locale}`,
		type: "config",
	}).then((res) => {
		if (res.siteMap[0]) {
			store.sitemap = res.siteMap[0].data.sitemap;
		}
	});
}
